export default __webpack_public_path__ + "static/cloud_cost_banner_1-b12e035e93295ceb092f10f24f6d426d.webp";